import React, { useMemo } from 'react'
import styled from 'styled-components'
import { ink, surface, line, radius, shadow, font, transition } from '../tokens'

const Panel = styled.div`
  background: ${surface.card};
  border: 1px solid ${line.base};
  border-radius: ${radius.md};
  box-shadow: ${shadow.card};
  padding: 12px;
`

const Heading = styled.div`
  font-size: ${font.caption};
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${ink.mute};
  margin-bottom: 10px;
`

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Item = styled.button`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  border: 1px solid ${line.base};
  border-radius: ${radius.sm};
  background: ${surface.wash};
  cursor: pointer;
  transition: ${transition};

  &:hover {
    border-color: ${line.strong};
    background: ${surface.card};
  }
`

const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const ItemTitle = styled.span`
  font-size: ${font.body};
  font-weight: 600;
  color: ${ink.base};
`

const ItemDescription = styled.span`
  font-size: ${font.small};
  color: ${ink.soft};
`

const AddCue = styled.span`
  flex: none;
  font-size: ${font.body};
  font-weight: 700;
  color: ${ink.soft};
`

const Empty = styled.div`
  font-size: ${font.body};
  color: ${ink.mute};
  padding: 8px 4px;
`

const WidgetPalette = ({ widgets, layout, onAdd }) => {
  const placed = useMemo(() => {
    const set = new Set()
    ;(layout || []).forEach(item => set.add(item.widgetKey))
    return set
  }, [layout])

  const available = useMemo(
    () => (widgets || []).filter(widget => !placed.has(widget.key)),
    [widgets, placed]
  )

  return (
    <Panel>
      <Heading>Add widget</Heading>
      {available.length === 0 ? (
        <Empty>All widgets added</Empty>
      ) : (
        <List>
          {available.map(widget => (
            <Item
              key={widget.key}
              type="button"
              onClick={() => onAdd && onAdd(widget)}
            >
              <ItemText>
                <ItemTitle>{widget.title}</ItemTitle>
                {widget.description && (
                  <ItemDescription>{widget.description}</ItemDescription>
                )}
              </ItemText>
              <AddCue aria-hidden="true">+</AddCue>
            </Item>
          ))}
        </List>
      )}
    </Panel>
  )
}

export default WidgetPalette
